export type BottomNavItemValue =
  | 'home'
  | 'secretariat'
  | 'article'
  | 'requests'
  | 'more'

export interface BottomNavItem {
  value: BottomNavItemValue
  icon: string
  activeIcon?: string
  label: string
  link?: string
  disabled?: boolean
}

export const BOTTOM_NAV_ITEMS: BottomNavItem[] = [
  {
    value: 'home',
    icon: 'home',
    activeIcon: 'homeFill',
    label: 'خانه',
    link: '/',
  },
  {
    value: 'secretariat',
    icon: 'secretariat',
    activeIcon: 'secretariatFill',
    label: 'دبیرخانه',
    link: '/secretariat',
  },
  {
    value: 'article',
    icon: 'graduationCap',
    activeIcon: 'graduationCapFill',
    label: 'آموزش',
    link: '/article',
  },
  {
    value: 'more',
    icon: 'gridSquare',
    activeIcon: 'gridSquareFill',
    label: 'بیشتر',
    link: '/profile',
  },
]

export function isBottomNavRootPath(path: string): boolean {
  return BOTTOM_NAV_ITEMS.some((item) => {
    if (!item.link || item.disabled) {
      return false
    }

    if (item.link === '/') {
      return path === '/'
    }

    return path === item.link
  })
}
